import { Button, TooltipDesktop, IconWarningSign16 } from '@cian/ui-kit';
import React, { useState } from 'react';

import { ComplaintModal } from './components/ComplaintModal';
import { ControlWrapper } from '../../../../components/ControlWrapper';

export function ComplainControlContainer() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <ControlWrapper>
        <TooltipDesktop theme="black" placement="left" title="Пожаловаться">
          <Button
            data-mark="ComplainControl"
            theme="stroke_secondary"
            onClick={() => setOpen(true)}
            size="XS"
            beforeIcon={<IconWarningSign16 />}
          />
        </TooltipDesktop>
      </ControlWrapper>
      <ComplaintModal onCloseModal={() => setOpen(false)} openModal={open} />
    </>
  );
}
